const actions = {
    COUPON_READ_REQUEST: 'COUPON_READ_REQUEST',
    COUPON_READ_SUCCESS: 'COUPON_READ_SUCCESS',
    COUPON_READ_ERROR: 'COUPON_READ_ERROR',
    COUPON_SET: 'COUPON_SET',
    COUPON_RESET: 'COUPON_RESET',

    read: (code, isPublic = false, discountOnly = false) => ({
        type: actions.COUPON_READ_REQUEST,
        code,
        isPublic,
        discountOnly,
    }),
    set: coupon => ({
        type: actions.COUPON_SET,
        coupon,
    }),
    reset: () => ({
        type: actions.COUPON_RESET,
    }),
};
export default actions;
